export default __webpack_public_path__ + "media/images/avatars/avatar11-e22782842a3d4d26f157d19ac9b5e50e.png";